import { IconBox, IconProps } from '@summer/jst-react-icon';

export const Download = (props: Omit<IconProps, 'ref'>) => (
  <IconBox {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.2745 33.5934L35.2746 6.00005L29.4564 6.00006L29.4563 33.5935L17.3452 21.4822L13.2311 25.5963L32.3653 44.7308L51.4998 25.5964L47.3857 21.4823L35.2745 33.5934Z"
    />
    <rect x="5" y="51" width="54" height="7" />
  </IconBox>
);
